<a-side :sub-menu="true">
	<ul class="aside-navigation">
		<li>
			<button type="button" class="btn--link-like" @click="helpHome " :title="$t('vm.root.help.aside.menu.help-home.title')">
				{{ $t('vm.root.help.aside.menu.help-home.label') }}
			</button>
		</li>
		<li>
			<button type="button" class="btn--link-like" @click="howItWorks" :title="$t('vm.root.help.aside.menu.how-it-works.title')">
				{{ $t('vm.root.help.aside.menu.how-it-works.label') }}
			</button>
		</li>
	</ul>
</a-side>
